import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { forceAppReload, isChunkRouteError } from "../utils/chunkLoadRecovery";

export default function RouteErrorPage() {
  const error = useRouteError();

  const message =
    (isRouteErrorResponse(error) && (error.statusText || error.data?.message)) ||
    error?.message ||
    "";

  const isChunkError = isChunkRouteError(error) || isChunkRouteError(message);

  return (
    <div className="min-h-dvh grid place-items-center bg-white px-6 py-12 text-center">
      <div className="max-w-md space-y-4">
        {isChunkError ? (
          <>
            <h1 className="text-xl font-semibold text-gray-900">
              Une nouvelle version est disponible
            </h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              Nous avons mis à jour l&apos;application. Rechargez la page pour
              continuer.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold text-gray-900">
              Une erreur est survenue
            </h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              {message || "Impossible d'afficher cette page pour le moment."}
            </p>
          </>
        )}
        <button
          type="button"
          onClick={forceAppReload}
          className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
        >
          {isChunkError ? "Actualiser" : "Réessayer"}
        </button>
      </div>
    </div>
  );
}
